import React, { useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import KYDTimePicker from "../../../ui/KYDTimePicker";
import dayjs from "dayjs";
import { useForm, Controller } from "react-hook-form";
import { KYDPerformerDisplay } from "@common/interfaces/KYDEvent";

interface SetTimeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: { time: dayjs.Dayjs | null; id: string }) => Promise<void>;
  // performerName: string;
  value: string | null;
  onChange: (val: string | null) => void;
  loading?: boolean;
  timezone: string;
  performer: KYDPerformerDisplay;
}

const SetTimeModal: React.FC<SetTimeModalProps> = ({
  isOpen,
  onClose,
  onSave,
  value,
  onChange,
  performer,
  loading = false,
  timezone,
}) => {
  const { control, handleSubmit, reset } = useForm<{
    time: dayjs.Dayjs | null;
    id: string;
  }>({
    defaultValues: {
      time: performer?.set_time
        ? dayjs(performer.set_time).tz(timezone)
        : undefined,
      id: performer?.id,
    },
  });

  // Reset form when modal opens or value changes
  useEffect(() => {
    reset({
      time: performer?.set_time ? dayjs(performer.set_time).tz(timezone) : null,
      id: performer?.id,
    });
  }, [isOpen, value, timezone, reset]);

  const onSubmit = (data: { time: dayjs.Dayjs | null; id: string }) => {
    onSave(data);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        reset();
        onClose();
      }}
      size={["full", "sm"]}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Set Time for {performer?.name}</ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <Controller
              name="time"
              control={control}
              render={({ field }) => (
                <KYDTimePicker
                  label="Set Time"
                  value={field.value}
                  onChange={field.onChange}
                  timezone={timezone}
                />
              )}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                reset();
                onClose();
              }}
              mr={3}
              isDisabled={loading}
            >
              Cancel
            </Button>
            <Button
              colorScheme="green"
              type="submit"
              isDisabled={loading}
              isLoading={loading}
            >
              Save
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default SetTimeModal;
